<template>
  <div class="credit-page">
    <div class="credit-card">
      <h3 class="form-title">💳 信用卡繳費排程</h3>
      <form @submit.prevent="set_schedular" class="styled-form">
        <div class="form-group">
          <label>繳費日期</label>
          <Datepicker v-model="picked" class="date-input" />
        </div>
        <div class="form-group">
          <label>信用卡</label>
          <select v-model="card" required>
            <option v-for="x in credit_card" :key="x">{{ x }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>金額</label>
          <div class="input-prefix">
            <span class="prefix">$</span>
            <input type="number" v-model="cost" placeholder="0" required />
          </div>
        </div>
        <button type="submit" class="btn-submit" :disabled="submitting">
          {{ submitting ? '處理中...' : '💳 設定繳費' }}
        </button>
      </form>
      <div v-if="success" class="toast toast-success">✅ 繳費排程已設定！</div>
      <div v-if="error" class="toast toast-error">❌ 請選擇未來的日期</div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
axios.defaults.baseURL = 'https://mb.kman.idv.tw:9579/';
import Datepicker from 'vue3-datepicker'

export default {
  components: { Datepicker },
  data() {
    return {
      picked: new Date(),
      credit_card: ['中信卡', '星展卡', '美運卡', '樂天卡'],
      cost: null,
      card: null,
      submitting: false,
      success: false,
      error: false
    };
  },
  methods: {
    async set_schedular() {
      this.success = false;
      this.error = false;
      const today = new Date();
      if (this.picked > today) {
        this.submitting = true;
        try {
          await axios.post('payment', {
            date: this.picked,
            card: this.card,
            cost: this.cost
          });
          this.cost = null;
          this.success = true;
          setTimeout(() => { this.success = false; }, 2500);
        } catch (e) {
          alert('設定失敗');
        } finally {
          this.submitting = false;
        }
      } else {
        this.error = true;
        setTimeout(() => { this.error = false; }, 2500);
      }
    }
  }
};
</script>
<style scoped>
.credit-page { max-width: 520px; margin: 0 auto; }
.credit-card {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  padding: 28px;
}
.form-title { font-size: 17px; font-weight: 700; margin-bottom: 20px; }
.styled-form { display: flex; flex-direction: column; gap: 14px; }
.form-group { display: flex; flex-direction: column; gap: 5px; }
.form-group label { font-size: 13px; font-weight: 600; color: var(--text-light); }
.form-group select,
.form-group input {
  padding: 10px 12px;
  font-size: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  outline: none;
  background: #fff;
  transition: border-color 0.15s;
}
.form-group select:focus,
.form-group input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79,70,229,0.1);
}
.date-input :deep(input) {
  padding: 10px 12px;
  font-size: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  outline: none;
  width: 100%;
}
.date-input :deep(input:focus) {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79,70,229,0.1);
}
.input-prefix { position: relative; }
.input-prefix .prefix {
  position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
  color: var(--text-light); font-size: 16px;
}
.input-prefix input { padding-left: 30px; width: 100%; }
.btn-submit {
  padding: 12px; font-size: 15px; font-weight: 600;
  background: var(--primary); color: #fff; border: none;
  border-radius: 8px; cursor: pointer; transition: all 0.15s; margin-top: 4px;
}
.btn-submit:hover { background: var(--primary-hover); }
.btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.toast {
  margin-top: 14px; padding: 10px 16px; border-radius: 8px;
  font-size: 14px; font-weight: 500; text-align: center; animation: fadeIn 0.3s;
}
.toast-success { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
.toast-error { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
</style>
